import footer from "@/components/footer/translations/footer-pl";
import home from "@/views/home/translations/home-pl";

const pl = {
  footer,
  home,
};

export default pl;
